import * as React from 'react';

import type { ExportsClient } from '@/api/exports-client';
import { HttpExportsClient } from '@/api/exports-client.http';

// =============================================================================
// exports-client-context.tsx — Injection de l'ExportsClient (DI seam).
// =============================================================================
// Substitue le client (double déterministe en test, impl navigateur réelle en prod)
// sans toucher l'UI. Par défaut : HttpExportsClient (téléchargement direct same-origin,
// GET → CSV, cookie de session porté par la navigation) — Phase 2 D2a-LECT. Le double
// StubExportsClient (`.stub.ts`) est injecté par les tests via le provider.

// Impl réelle par défaut (Phase 2, D2a-LECT). Instance partagée (sans état interne).
const defaultExportsClient: ExportsClient = new HttpExportsClient();

const ExportsClientContext =
  React.createContext<ExportsClient>(defaultExportsClient);

export interface ExportsClientProviderProps {
  client?: ExportsClient | undefined;
  children: React.ReactNode;
}

export function ExportsClientProvider({
  client = defaultExportsClient,
  children,
}: ExportsClientProviderProps): React.JSX.Element {
  return (
    <ExportsClientContext.Provider value={client}>
      {children}
    </ExportsClientContext.Provider>
  );
}

export function useExportsClient(): ExportsClient {
  return React.useContext(ExportsClientContext);
}
